import type { Column } from "@/types/array.types";

export function validateForm<T>(
    values: Partial<T>,
    columns: Column<T>[]
  ): Partial<Record<keyof T, string>> {
    const errors: Partial<Record<keyof T, string>> = {};
  
    columns.forEach((column) => {
      const value = values[column.key];
  
      if (
        column.required &&
        (value === "" || value === undefined || value === null)
      ) {
        errors[column.key] = `${column.label} est obligatoire.`;
        return;
      }
  
      if (column.validate) {
        const error = column.validate(value as T[keyof T]);
  
        if (error) {
          errors[column.key] = error;
        }
      }
    });
  
    return errors;
  }